export default __webpack_public_path__ + "static/media/mango.ac53d5ec.jpg";